import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";
import store from "./store/store";
import Buefy from "buefy";
//import "buefy/dist/buefy.css";
import { initializeApp } from "firebase/app";
import "leaflet/dist/leaflet.css";
import "../node_modules/@fortawesome/fontawesome-free/js/all.js";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faFilePen } from "@fortawesome/free-solid-svg-icons";
import { faChartColumn } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

library.add(faFilePen, faUser, faChartColumn);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.use(Buefy);
Vue.config.productionTip = false;

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC_fGUW8NYhBFa5SscBvSBmu4vCXBG-LCU",
  authDomain: "mhconseil-e7605.firebaseapp.com",
  projectId: "mhconseil-e7605",
  storageBucket: "mhconseil-e7605.appspot.com",
  messagingSenderId: "563058115524",
  appId: "1:563058115524:web:d10f2b9377b0fdc0c39a91",
};

const app = initializeApp(firebaseConfig);
// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

Vue.filter("userName", function (profil) {
  if (profil != undefined) {
    return (
      profil.name.charAt(0).toUpperCase() +
      profil.name.slice(1) +
      " " +
      profil.surname.charAt(0).toUpperCase() +
      profil.surname.slice(1)
    );
  } else {
    return "-";
  }
});

const auth = getAuth();
onAuthStateChanged(auth, (user) => {
  store.dispatch("fetchUser", user);
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
